window.addEventListener("load", function() {
  const toc = document.querySelector(".table-of-contents");
  if (!toc) return;
  if (toc.scrollHeight > 750) {
    toc.style.maxHeight = "750px";
    toc.style.overflow = "hidden";
    const button = document.createElement("button");
    button.textContent = "もっと見る";
    button.className = "toc-toggle-btn";
    toc.insertAdjacentElement("afterend", button);

    button.addEventListener("click", function() {
      toc.classList.toggle("expanded");

      if (toc.classList.contains("expanded")) {
        toc.style.maxHeight = "none";
        this.textContent = "閉じる";
      } else {
        toc.style.maxHeight = "750px";
        this.textContent = "もっと見る";
      }
    });
  }
});